"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpFormSelect2 = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const vue_property_decorator_1 = require("vue-property-decorator");
const form_input_base_1 = require("./form-input-base");
const form_select2_html_1 = __importDefault(require("./form-select2.html"));
const log = (0, debug_1.default)('itp:ui:components:forms:form-select2');
const LABEL = 'label';
const isAsyncOptions = (value) => _.isFunction(value);
let ItpFormSelect2 = class ItpFormSelect2 extends (0, vue_property_decorator_1.Mixins)(form_input_base_1.FormInputBase) {
    _searchCounter;
    selectOptions;
    dataSource;
    prefetch;
    options;
    initialOptions;
    multiple;
    bindObject;
    optionValueField;
    valueField;
    textField;
    textFieldSeparator;
    disabledField;
    filterable;
    filterBy;
    template;
    clearable;
    footerTemplate;
    headerTemplate;
    listFooterTemplate;
    listHeaderTemplate;
    noOptionsMessage;
    noOptionsTemplate;
    optionTemplate;
    useOptionTemplateForSelectedOption;
    selectedOptionTemplate;
    taggable;
    groupBy;
    groupHeader;
    hackData() {
        return { _searchCounter: null };
    }
    get bindings() {
        return {
            name: this.name,
            readonly: this.readonly,
            taggable: this.taggable,
            prefetch: this.prefetch,
            footerTemplate: this.footerTemplate,
            headerTemplate: this.headerTemplate,
            listFooterTemplate: this.listFooterTemplate,
            listHeaderTemplate: this.listHeaderTemplate,
            noOptionsMessage: this.noOptionsMessage,
            noOptionsTemplate: this.noOptionsTemplate,
            optionTemplate: this.optionTemplate,
            groupBy: this.groupBy,
            groupHeader: this.groupHeader,
            useOptionTemplateForSelectedOption: this
                .useOptionTemplateForSelectedOption,
            selectedOptionTemplate: this.selectedOptionTemplate
        };
    }
    search(query) {
        const prefetch = this.dataSource && this.prefetch && !this._searchCounter;
        if (!prefetch &&
            (!this.dataSource || query == null || query.trim() === '')) {
            return [];
        }
        let ds = this.dataSource;
        if (_.isFunction(ds)) {
            ds = ds();
        }
        if (prefetch) {
            query = '*';
        }
        this._searchCounter = (this._searchCounter || 0) + 1;
        return this.$app.connections
            .request(ds.name, { parameters: { ...ds.parameters, query } })
            .then(resp => resp.data);
    }
};
exports.ItpFormSelect2 = ItpFormSelect2;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpFormSelect2.prototype, "dataSource", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false }),
    __metadata("design:type", Boolean)
], ItpFormSelect2.prototype, "prefetch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpFormSelect2.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Array)
], ItpFormSelect2.prototype, "initialOptions", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormSelect2.prototype, "multiple", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormSelect2.prototype, "bindObject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "optionValueField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "valueField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'label' }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "textField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: ' ' }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "textFieldSeparator", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "disabledField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "filterable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "filterBy", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "template", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormSelect2.prototype, "clearable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "footerTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "headerTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "listFooterTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "listHeaderTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "noOptionsMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "noOptionsTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "optionTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormSelect2.prototype, "useOptionTemplateForSelectedOption", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "selectedOptionTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormSelect2.prototype, "taggable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "groupBy", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormSelect2.prototype, "groupHeader", void 0);
exports.ItpFormSelect2 = ItpFormSelect2 = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: form_select2_html_1.default,
        inject: {
            componentContext: 'componentContext',
            formContext: { default: null }
        }
    })
], ItpFormSelect2);
//# sourceMappingURL=form-select2.js.map